import request from '@/utils/axios';

export function updateUserInfo(params) {
  return request({
    url: '/api/user/pc/user/update/info',
    method: 'post',
    data: params
  })
}

// 创建/保存收货地址
export function saveAddress(params) {
  return request({
    url: '/api/user/wx/address/save',
    method: 'post',
    data: params,
    headers: {
      'host': window.location.host
    }
  })
}

// 获取默认地址信息
export function getDefaultAddress() {
  return request({
    url: '/api/user/wx/address/get/default',
    method: 'get'
  })
}